import React from 'react';
import styled from 'styled-components';
import { device } from '../utils/devices';
import { Link, scroller } from 'react-scroll';

const NavBlock = styled.nav`
  display: none;

  @media ${device.laptop} {
    display: block;
    padding: 4rem;
    min-height: 40px;
  }
`;

const List = styled.ul`
  padding: 0;
  margin: 0;
  font-size: 24px;
  list-style-type: none;
  display: flex;
  justify-content: space-between;
`;

const ListItem = styled.li`

a {
  cursor: pointer;
}
`;


const scrollTo = (element) => {
    console.log(element)
    scroller.scrollTo(element, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart'
    })
  }

const Nav = (props) => {


  return (
    <NavBlock>
      <List>
        <ListItem><a to="studio" onClick={() => scrollTo('studio')} >Studio</a></ListItem>
        <ListItem><a to="photos" onClick={() => scrollTo('photos')} >Photos</a></ListItem>
        <ListItem><a to="pricing" onClick={() => scrollTo('pricing')} >Pricing</a></ListItem>
        <ListItem><a to="amenities" onClick={() => scrollTo('amenities')} >Amenities</a></ListItem>
        <ListItem><a to="equipment" onClick={() => scrollTo('equipment')} >Equipment</a></ListItem>
        <ListItem><a to="contact" onClick={() => scrollTo('contact')} >Contact</a></ListItem>
      </List>
    </NavBlock>
  )
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav.js